<template>
  <div
    v-if="filterStore.available.groups &&filterStore.available.groups.length > 1"
    :class="$style['filter']">
    <div :class="$style['filter__title']">
      {{ $t('general/filter-producttype') }}

      <Btn v-if="filterStore.active.groups.length" icon-right="System/close-line" color="link" size="small" @click="filterStore.resetFilter('groups')">
        Reset filter
      </Btn>
    </div>

    <FormCheckbox
      v-for="row in activeGroups"
      :key="row.value"
      checked
      :target-value="row.value.toLowerCase()"
      :label="row.title"
      :sub-label="row.count ? row.count : '0'"
      :disabled="!row.count"
      @input="
        filterStore.toggle({
          filter: 'groups',
          value: row.value
        })
      " />

    <div
      :class="[$style['expander'], { [$style['expander--expand']]: expand }]">
      <FormCheckbox
        v-for="row in nonActiveGroups"
        :key="row.value"
        :class="$style['expander__item']"
        :checked="false"
        :target-value="row.value.toLowerCase()"
        :label="row.title"
        :sub-label="row.count ? row.count : '0'"
        :disabled="!row.count"
        @input="
          filterStore.toggle({
            filter: 'groups',
            value: row.value
          })
        " />

      <Btn
        v-if="Object.keys(filterStore.available.groups).length > 5"
        full-width="all"
        size="small"
        color="link"
        class="h-margin-top"
        @click="expand = !expand">
        {{
          expand
            ? $t('general/filter-less-types')
            : $t('general/filter-more-types')
        }}
      </Btn>
    </div>
  </div>
</template>
<script setup>
const filterStore = useFilterStore()
const expand = ref(false)

const activeGroups = computed(() => {
  return filterStore.available.groups
    .filter(group => {
      return filterStore.active.groups.includes(group.value) && group.count > 0
    })
    .sort((a, b) => a.count < b.count ? 1 : -1)
})

const nonActiveGroups = computed(() => {
  return filterStore.available.groups
    .filter(group => {
      return !filterStore.active.groups.includes(group.value)
    })
    .sort((a, b) => a.count < b.count ? 1 : -1)
})
</script>
<style lang="scss" module>
@use './style' as *;
</style>
